import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import authReducer from "features/slices/authSlice";
import tenantReducer from "features/slices/tenantSlice";
import buyFlowReducer from "features/slices/buyFlowSlice";
import themeReducer from "features/slices/themeSlice";
import reservationFlowReducer from "features/slices/reservationFlowSlice";
import loginFlowReducer from "features/slices/loginFlowSlice";
import addMembershipFlowReducer from "features/slices/addMembershipFlowSlice";
import shopPagePhaseTwoReducer from "features/slices/shopPagePhaseTwoSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tenant: tenantReducer,
    theme: themeReducer,
    reservationFlow: reservationFlowReducer,
    buyFlow: buyFlowReducer,
    loginFlow: loginFlowReducer,
    addMembershipFlow: addMembershipFlowReducer,
    shopPagePhaseTwo: shopPagePhaseTwoReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
